import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

class FilterPod extends Component {
    static propTypes = {
        onToggleVisibility: PropTypes.func,
        title: PropTypes.any,
        className: PropTypes.string,
        isOpen: PropTypes.bool,
        reset: PropTypes.any,
        resetHandler: PropTypes.func,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        onToggleVisibility: () => {},
        className: "",
        isOpen: true,
        reset: false,
        disabled: false
    }

    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen
        }

        this.toggleVisibility = this.toggleVisibility.bind(this);
    }

    toggleVisibility() {
        if (this.props.onToggleVisibility) {
            this.props.onToggleVisibility(!this.state.isOpen);
        }

        this.setState({ isOpen: !this.state.isOpen})
    }

    render() {
        return (
            <div className={this.props.className + " filter-pod " + (this.state.isOpen ? "" : "closed")}>
                <div className="filter-pod__header-container">
                    <h3 onClick={this.toggleVisibility}>{this.props.title}</h3>
                    {this.props.helperIcon ? this.props.helperIcon : null}
                    {this.props.reset && (
                        <div className="reset-btn" onClick={this.props.resetHandler}>{this.props.reset}</div>
                    )}
                </div>
                <div className="filter-pod__content">
                    {this.props.children}
                </div>
            </div>
        )
    }

}

export default injectIntl(FilterPod);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Filters/FilterPod.jsx